import classNames from 'classnames'
import React from 'react'

const Spinner = ({
    width = "3rem" || 48,
    height = "3rem" || 48,
    color = "rgba(51, 201, 255, 0.8)",
    backgroundColor = "rgba(0, 174, 239, 0.2)",
    speed = 3000,
    weight = 4,
    ...props
}) => {
    const spinnerStyles = {
        display: 'block',
        margin: 'auto',
        height: '100%',
        width: '100%',
        border: `${weight}px solid ${backgroundColor}`,
        borderTopColor: color,
        borderRadius: '50%',
        animation: `rotation ${speed}ms infinite linear`,
    }

    return (
        <>
            <div {...props} style={{ width, height, ...props?.style }} className={classNames("flex justify-center items-center animate-spin", props?.className)}>
                <div className="spinner" style={spinnerStyles} />
            </div>
        </>
    )
}

export default Spinner